/**
 *
 * Labels
 *
 */

import styled from 'styled-components';

import { COLORS } from 'utils/constants';

const Label = styled.label`
    font-size: .875rem;
    color: ${COLORS.siteBlue};
`;

export default Label;



// WEBPACK FOOTER //
// ./src/components/Label/index.js